import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi,
} from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { KDOAuthenticationModule } from "@kdose/ng-auth";
import { KDOCrudModule } from "@kdose/ng-crud";
import { SpringBootUiModule } from "@kdose/ng-spring-boot-ui";
import Lara from "@primeng/themes/lara";
import { ConfirmationService, MessageService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";
import { environment } from "../environments/environment";
import PrimeNGTranslation from "../environments/primeNgTranslation.json";
import { AppComponent } from "./app.component";
import { ROUTES } from "./app.routes";
import { AuthorityCrudModule } from "./authority/authority.module";
import { ChangePasswordModule } from "./change-password/change-password.module";
import { ClientCrudModule } from "./client";
import { baseCrudUrlGetter } from "./config-getter";
import { EndPointModule } from "./endPoint";
import { CertificateCrudModule } from "./key/certificate/certificate.module";
import { KeyCrudModule } from "./key/key.module";
import { PrivateKeyCrudModule } from "./key/private-key/private-key.module";
import { PipesModule } from "./pipes/pipes.module";
import { SharedModule } from "./shared";
import { Data } from "./shared/data";
import { HttpErrorInterceptorService } from "./shared/http-error-interceptor.service";
import { HttpInterceptorService } from "./shared/http-interceptor.service";
import { HTTP_OPTIONS } from "./shared/http-options.token";
import { NextaCrudModule } from "./shared/nexta-crud/crud.module";
import { NotificationService } from "./shared/notification.service";
import { UserCrudModule } from "./user";

// Application wide providers
const APP_PROVIDERS = [
	ConfirmationService,
	MessageService,
	NotificationService,
	Data,
	{ provide: HTTP_OPTIONS, useValue: { contentType: "application/json" } },
	{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
	{
		provide: HTTP_INTERCEPTORS,
		useClass: HttpErrorInterceptorService,
		multi: true,
	},
];

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
	bootstrap: [AppComponent],
	declarations: [AppComponent],
	imports: [
		// import Angular's modules
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forRoot(ROUTES, { useHash: false }),
		ChangePasswordModule,
		ConfirmDialogModule,
		ToastModule,
		SpringBootUiModule.forRoot({
			baseUrl: "actuator",
			logfile: {
				nameTemplate: `XTA-Soap-Proxy_${environment.version}_\${luxon:yyyy-MM-dd_HH-mm-ss}.txt`,
			},
			metrics: ["."],
		}),
		NextaCrudModule.forRoot(),
		SharedModule,
		PipesModule,
		CertificateCrudModule,
		PrivateKeyCrudModule,
		KeyCrudModule,
		AuthorityCrudModule,
		EndPointModule,
		UserCrudModule,
		ClientCrudModule,
		KDOAuthenticationModule.forRoot({
			additionalPostHeaders: {
				"X-KDO-NO-CONTENT-TYPE": "X-KDO-NO-CONTENT-TYPE",
			},
			baseUrl: baseCrudUrlGetter(),
			loginRoute: "/login",
		}),
		KDOCrudModule.forRoot({
			config: {
				baseUrl: baseCrudUrlGetter,
			},
		}),
	],
	providers: [
		APP_PROVIDERS,
		provideHttpClient(withInterceptorsFromDi()),
		providePrimeNG({
			theme: {
				preset: Lara,
			},
			translation: PrimeNGTranslation,
		}),
	],
})
export class AppModule {}
